'use strict';

module.exports = require('es5-ext/object/primitive-set')('key',
	'value', 'key+value');



//////////////////
// WEBPACK FOOTER
// ./~/es6-map/lib/iterator-kinds.js
// module id = 431
// module chunks = 0